var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContest28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.055c0-.929.599-1.742 1.51-1.92C7.96 2.848 10.457 2.5 14 2.5s6.04.349 7.49.634c.911.18 1.51.992 1.51 1.921V9c0 4.372-3.117 8.015-7.25 8.83v1.487c0 .57 0 .854.064 1.1a2 2 0 0 0 1.005 1.269c.225.119.502.184 1.056.314l.178.042c.385.09.577.136.739.205a2 2 0 0 1 1.177 1.487c.031.174.031.371.031.766 0 0 0 1-6 1s-6-1-6-1c0-.395 0-.592.03-.766a2 2 0 0 1 1.178-1.487c.162-.07.354-.115.739-.205l.178-.042c.554-.13.831-.195 1.056-.314a2 2 0 0 0 1.005-1.269c.064-.246.064-.53.064-1.1V17.83C8.117 17.016 5 13.372 5 9V5.055Zm9 .445c-.356 0-.58.426-1.027 1.28l-.149.284c-.13.249-.195.373-.31.451-.114.078-.26.098-.552.138l-.333.046c-1 .137-1.5.205-1.61.524-.11.318.252.65.976 1.314l.24.221c.212.194.318.29.361.417.044.127.019.264-.03.537l-.058.313c-.17.937-.256 1.406.032 1.603.288.197.735-.025 1.63-.467l.297-.148c.261-.129.392-.194.533-.194.141 0 .272.065.533.194l.298.148c.894.442 1.341.664 1.63.467.287-.197.202-.666.03-1.604l-.056-.312c-.05-.273-.075-.41-.031-.537.044-.126.149-.223.36-.417l.241-.221c.724-.664 1.086-.996.976-1.314-.11-.32-.61-.387-1.61-.524l-.333-.046c-.292-.04-.438-.06-.552-.138-.115-.078-.18-.202-.31-.451l-.15-.285C14.58 5.926 14.357 5.5 14 5.5Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContest28);
export default __webpack_public_path__ + "static/media/contest_28.09e848a7.svg";
export { ForwardRef as ReactComponent };